import { BodyText, theme } from 'modules/ui';
import styled from 'styled-components';
import { StyledButton } from '../../../../ui/button/styled';

export const QrImage = styled.img`
  width: 12.5rem !important;
`;

export const NoMarginBodyText = styled(BodyText)`
  margin: 0;
`;

export const StyledTextLink = styled(StyledButton)`
  padding-bottom: 3px;
  text-transform: lowercase;
  font-size: ${theme.fontSizes.body};
`;
